import { Component, EventEmitter, OnInit, Output, SecurityContext } from '@angular/core';
import { IdentitaetPruefenResult } from 'app/core/services/api-client';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { MergeActions, MergeSelectors } from './ducks/store';
import { DomSanitizer } from '@angular/platform-browser';
import { I18nService } from 'app/core/services/i18n/i18n.service';
import { IAppState } from 'app/modules/shared-area/root-state';

@Component({
  selector: 'app-merge-dialog',
  templateUrl: './merge-dialog.component.html',
})
export class MergeDialogComponent implements OnInit {
  public isBusy$: Observable<boolean>;
  public canMerge$: Observable<boolean>;
  public result$: Observable<IdentitaetPruefenResult>;
  public additionalId: any;

  @Output()
  public closeWindow: EventEmitter<any | null> = new EventEmitter<any | null>();

  constructor(
    private store: Store<IAppState>,
    private i18n: I18nService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.isBusy$ = this.store.pipe(select(MergeSelectors.isBusy));
    this.canMerge$ = this.store.pipe(select(MergeSelectors.canMerge));
    this.result$ = this.store.pipe(select(MergeSelectors.getResult));
  }

  checkAdditional(): boolean {
    if (this.additionalId) {
      const additionalIdValue = Number.parseInt(this.additionalId, 10);
      if (additionalIdValue) {
        return true;
      }
    }
    return false;
  }

  merge() {
    if (this.additionalId) {
      const additionalIdValue = Number.parseInt(this.additionalId, 10);
      if (additionalIdValue) {
        console.log(additionalIdValue);
        this.store.dispatch(MergeActions.merge({ additionalId: additionalIdValue }));
      }
    } else {
      console.log('Without additional ID');
      this.store.dispatch(MergeActions.merge({ additionalId: null }));
    }
  }

  format(text: string): string {
    const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, text);
    return sanitized.replace(/(&#10;)/g, '<br>');
  }

  formatIdentitiesText(n: number): string {
    if (n === 0) {
      return this.i18n.getLocalizedString('components.merge.identitiesText0');
    } else if (n === 1) {
      return this.i18n.getLocalizedString('components.merge.identitiesText1');
    }
    return this.i18n.getLocalizedString('components.merge.identitiesTextN').replace('{{n}}', n.toString());
  }

  close() {
    this.closeWindow.emit(null);
  }
}
